import { request } from './request'
/**
 *  请求首页赛事公告数据
 */
export function getHomeData () {
  return request({
    url: '/news/match',
    post: 'get'
  })
}
